package com.shadowings.gero.data.lessons.chapter16

import com.shadowings.gero.data.lessons.calculateNounAdjectivePhrases
import com.shadowings.gero.data.repository.AdjectivePairs
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_1
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_10
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_11
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_2
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_3
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_4
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_5
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_6
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_7
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_8
import gero.composeapp.generated.resources.exp_content_aggettivi_plurale_9
import gero.composeapp.generated.resources.exp_title_aggettivi_plurale
import gero.composeapp.generated.resources.quiz_aggettivi_plurale_tf_1
import gero.composeapp.generated.resources.quiz_aggettivi_plurale_tf_2
import gero.composeapp.generated.resources.quiz_aggettivi_plurale_tf_3
import gero.composeapp.generated.resources.quiz_aggettivi_plurale_tf_4
import kotlin.random.Random

fun getAggettiviPluraleContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_1,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_3,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_4,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_5,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_6,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("D21:V13-A1-Z3-F35-G43"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_7,
            face = Faces.Doubt,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_8,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = mdcSlide("F35-X1:Z2"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_9,
            face = Faces.Idle,
            character = Characters.Alyn,
            composable = mdcSlide("O34:X1-B1-B1-F35-X1:Z2"),
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_10,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_aggettivi_plurale,
            content = Res.string.exp_content_aggettivi_plurale_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

// 4 plural translations + 4 "pick the right hieroglyphs" (2 plural, 2 singular, each with the
// wrong-number option too), half masculine and half feminine, + 2 true/false on the rule.
fun getAggettiviPluraleQuizContent(
    words: List<Word>,
    languageCode: String,
    random: Random = Random,
    adjectivePairs: List<AdjectivePairs> = DatabaseRepositoryImpl.adjectivePairs
): List<IQuizContent> {
    val plurals = calculateNounAdjectivePhrases(words, adjectivePairs, languageCode, plural = true)
    val singulars =
        calculateNounAdjectivePhrases(words, adjectivePairs, languageCode, plural = false)
    val (translate, choosePlural) = pickPerGender(plurals, listOf(2, 1), random)
    val (chooseSingular) = pickPerGender(singulars, listOf(1), random)
    val theory = listOf(
        TrueFalseContent(Res.string.quiz_aggettivi_plurale_tf_1, true),
        TrueFalseContent(Res.string.quiz_aggettivi_plurale_tf_2, false),
        TrueFalseContent(Res.string.quiz_aggettivi_plurale_tf_3, true),
        TrueFalseContent(Res.string.quiz_aggettivi_plurale_tf_4, false),
    ).shuffled(random).take(2)

    return (
            buildAdjectiveAgreementQuizzes(
                translate = translate,
                choose = choosePlural + chooseSingular,
                pool = plurals,
                includeNumber = true,
                languageCode = languageCode,
                random = random
            ) + theory
            ).shuffled(random)
}
